import { serialize } from "@/utils";

export default {
  namespaced: true,
  state: {
    path: "aljabr/telegram-api/legal/chats",
  },
  actions: {
    get({ dispatch, state }, options) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/?${serialize(options)}`,
          method: "GET",
          data: {},
        },
        { root: true }
      );
    },
    "add-message"({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/add-message`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
    "finish-chat"({ dispatch, state }, data) {
      return dispatch(
        "FETCH",
        {
          url: `${state.path}/finish-chat`,
          method: "POST",
          data,
        },
        { root: true }
      );
    },
  },
};
